import * as React from 'react';
import { FavouriteInstance } from 'app/area/favourite/favourite-context';
import { ReportViewFavourite } from 'app/area/company-report/report-view-favourite';
import { reportTranslation } from 'app/area/company-report/constants';
import { STATE } from 'app/constants';
import { useTranslation } from 'app/infrastructure/translate/hooks';
import { useSharedState } from 'app/infrastructure/redux/hooks';
import { 
  useActionCreators,
  useLoadMetadataEffect,
  useSelectors
} from 'app/area/company-report/hooks';

interface ReportViewProps {
  companyReportId: number;
  editSavedFavourite: boolean;
  favouriteId: number;
}

export function ReportView({
  companyReportId,
  editSavedFavourite,
  favouriteId
}: ReportViewProps) {

  const translation = useTranslation(STATE.companyReport, reportTranslation);

  const sharedState = useSharedState();

  const {
    metadata,
    emails,
    fetchingReport,
    fetchingMetadata,
    emailsValidation,
    fetchingSpecialReport
  } = useSelectors();

  const {
    setEmail
  } = useActionCreators();

  useLoadMetadataEffect(companyReportId);

  if(fetchingSpecialReport) {
    return null;
  }

  return (
    <FavouriteInstance>
      <ReportViewFavourite
        translation={translation}
        sharedState={sharedState}
        companyReportId={companyReportId}
        onChangeEmail={setEmail}
        metadata={metadata}
        emails={emails}
        fetchingReport={fetchingReport}
        fetchingMetadata={fetchingMetadata}
        emailsValidation={emailsValidation}
        editSavedFavourite={editSavedFavourite}
        favouriteId={favouriteId}
      />
    </FavouriteInstance>
  );
}
